<template>
  <div class="wrap">
    <h3><strong>You are in safe hands</strong></h3>
    <p class="text-center">
      We partner with Industry leaders to offer you the best serivce possible
    </p>
    <ul class="clients">
      <li>
        <a href=""
          ><img :src="require('@/assets/partnerLogos/stitch.jpg')" alt="Google"
        /></a>
      </li>
      <li>
        <a href=""
          ><img
            :src="require('@/assets/partnerLogos/Payfast-Logo-DPO-Stacked.svg')"
            alt="Airbnb"
        /></a>
      </li>
      <li>
        <a href=""
          ><img :src="require('@/assets/partnerLogos/genric.jpg')" alt="Apple"
        /></a>
      </li>
      <li>
        <a href=""
          ><img
            :src="require('@/assets/fontawesome/dumbbell-duotone.svg')"
            alt="Microsoft"
        /></a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "StrappLogos",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 4.8rem;
  position: relative;
  width: 90%;
}
h3 {
  font-size: 2.4rem;
  font-weight: 600;
  text-align: center;
}
.clients {
  align-items: center;
  -webkit-box-align: center;
  display: grid;
  gap: 4.8rem 4.8rem;
  grid-template-columns: auto auto;
  justify-items: center;
  margin: 4.8rem auto;
  max-width: 1024px;
}

.clients li {
  list-style: none;
  margin: 0;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.clients img {
  height: 3.2rem;
}
.clients:hover li {
  filter: blur(0px);
  -webkit-filter: blur(0px);
}
.clients:hover li:not(:hover) {
  filter: blur(2px);
  -webkit-filter: blur(2px);
}
.clients li:hover {
  -webkit-transform: translateY(-0.3rem);
  transform: translateY(-0.3rem);
}

@media (min-width: 1024px) {
  .clients {
    grid-template-columns: auto auto auto auto;
  }

  .clients img {
    height: 4rem;
  }
}

/* --- Images (gray logo) --- */
.clients img {
  -webkit-filter: grayscale(100%) brightness(10%) contrast(10%);
  filter: grayscale(100%) brightness(10%) contrast(10%);
}

.clients img:hover {
  background: none;
  -webkit-filter: grayscale(0%);
  filter: grayscale(0%);
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
</style>
